import { FC } from 'react';
import { clx } from 'Utils';
import styles from 'partials/card/subscription-card.module.scss';

// Inline skeleton style
const skeletonStyle: React.CSSProperties = {
	minHeight: '20px',
	width: '120px'
};

const skeletonLabelStyle: React.CSSProperties = {
	minHeight: '20px',
	width: '80px'
};

export const SkeletonDetailsInvoice: FC = () => {
	const row_class = 'justify-content-between';

	return (
		<div>
			<h6 className="text-gray-3 mb-3 fs-6 fw-400 d-flex align-items-center justify-content-between">
				<span className="skeletonStyle" style={skeletonStyle} />
			</h6>
			<div className={clx(styles.row, row_class)}>
				<span className={styles.rowLabel}>
					<span
						className="skeletonStyle"
						style={skeletonLabelStyle}
					/>
				</span>
				<span className="fs-6">
					<span className="skeletonStyle" style={skeletonStyle} />
				</span>
			</div>
			<div
				className={clx(styles.row, 'justify-content-between border-0')}>
				<span className={styles.rowLabel}>
					<span
						className="skeletonStyle"
						style={skeletonLabelStyle}
					/>
				</span>
				<span>
					<span className="skeletonStyle" style={skeletonStyle} />
				</span>
			</div>
			<hr className="bg-gray-2 mb-3" />
			<div className={clx(styles.row, row_class)}>
				<span className={styles.rowLabel}>
					<span
						className="skeletonStyle"
						style={skeletonLabelStyle}
					/>
				</span>
				<span>
					<span className="skeletonStyle" style={skeletonStyle} />
				</span>
			</div>

			<div className={clx(styles.row, row_class)}>
				<span className={styles.rowLabel}>
					<span
						className="skeletonStyle"
						style={skeletonLabelStyle}
					/>
				</span>
				<span>
					<span className="skeletonStyle" style={skeletonStyle} />
				</span>
			</div>

			<div className={clx(styles.row, row_class)}>
				<span className={styles.rowLabel}>
					<span
						className="skeletonStyle"
						style={skeletonLabelStyle}
					/>
				</span>
				<span>
					<span className="skeletonStyle" style={skeletonStyle} />
				</span>
			</div>
			<div className={clx(styles.row, row_class)}>
				<span className={styles.rowLabel}>
					<span
						className="skeletonStyle"
						style={skeletonLabelStyle}
					/>
				</span>
				<span>
					<span className="skeletonStyle" style={skeletonStyle} />
				</span>
			</div>
			<div className={clx(styles.row, row_class)}>
				<span className={clx(styles.rowLabel, 'fw-500')}>
					<span
						className="skeletonStyle"
						style={skeletonLabelStyle}
					/>
				</span>
				<div className="d-flex flex-column text-end">
					<span className="fs-6 fw-500">
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>
					<span className="text-gray-3 lh-base fs-small">
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>
				</div>
			</div>
		</div>
	);
};
